import _ from 'lodash';
import { post } from './core/fetch';

export const globalSearch = async (key: string) => {
	try {
		const SUGGESTED_SEARCH_NUM = '10';
		var srcRef = '/searchapi/v2/mlcadvisersecure/suggested';
		var searchData = {};
		// @ts-ignore
		searchData.numSuggestedSearches = SUGGESTED_SEARCH_NUM;

		const json: any = await post(`${srcRef}/${key}`, searchData);
		// @ts-ignore
		return _.map(json.body.suggested, item => ({ id: item, label: item }));
	} catch (e) {
		return [];
	}
};
